'use strict';

var App = App || {};

// Handles the agax and search results placement when a search is triggered from any search field.
App.SiteSearch = function () {
  'use strict';

  var $searchInput = $('.site-search-input'),
      $searchResultsModal = $('#search-results-modal');

  var initialize = function initialize(args) {
    _bindSearchFieldEnter();
    _bindSearchResultsClose();
  };

  var _bindSearchFieldEnter = function _bindSearchFieldEnter() {
    // When the enter button is hit inside a search field, trigger this
    // Get contents and pass them to the search function
    $(document).on('keyup', '.site-search-input', function (e) {
      e.preventDefault();
      var query = $(this).val();

      if (e.keyCode == 13 && query != null && query != '') {
        _executeSearch(query.toString());
      } else if (e.keyCode == 13 && (query == null || query == '' || query == ' ')) {
        $(this).attr('placeholder', 'please enter a search term');
      }
    });
  };

  var _bindSearchResultsClose = function _bindSearchResultsClose() {
    $(document).on('click', '.js-close-search-results', function (e) {
      e.preventDefault();
      $searchResultsModal.foundation('close');
    });
  };

  var _executeSearch = function _executeSearch(query) {
    var results = _getSearchResults(query);

    _renderResults(results);
  };

  // This takes a query and returns the results of the ajax call made with it.
  var _getSearchResults = function _getSearchResults(query) {
    // URL of the search page.
    // The search page only returns markup to be inserted in the results overlay.
    // The search page is never rendered on it's own.
    var searchUrl = window.location.origin + "/search/",
        searchResults,
        formattedQuery;

    formattedQuery = { 'siteSearchQuery': query.toString() };

    searchResults = $.ajax({
      async: false,
      url: searchUrl,
      type: 'POST',
      data: formattedQuery,
      dataType: 'html'
    }).done(function (content, textStatus, jqXHR) {
      searchResults = jqXHR;
    }).fail(function () {
      console.log("error");
      searchResults = "Sorry your search could not be completed at this time.";
    }).always(function () {
      console.log("complete");
    });

    return searchResults;
  };

  var _renderResults = function _renderResults(results) {
    //Close navigation since there was some unpredictable behavior when nav tried to close when clicking somewhere in the search results modal.
    // Only close the nav if it's open (prevents a nav flash)
    if ($('.site-nav').hasClass('open')) {
      App.SiteNavigation.closeNavigation();
      $('.nav-action-item .site-search-input').val('');
    }

    $('#search-results-modal .search-results-content').html(results.responseText);
    // Only open the modal if it's not open. Prevents a flash of the modal.
    if (!$searchResultsModal.is(':visible')) $searchResultsModal.foundation('open');
  };

  return {
    initialize: initialize
  };
}();